import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { validateInitialBulkIsFilledCorrectly } from 'UI/components/organisms/BulkEmailDrawer/utils';
import { BulkDrawerFormFieldsMap } from 'UI/components/organisms/BulkEmailForm/fields';
import { getId } from 'UI/utils';

import { buildAttemptsFormKey } from '../BulkSequences.utils';

const attemptsFormFieldKey = BulkDrawerFormFieldsMap.Attempts.key;

export const useBulkDrawerAttemptsHandlers = () => {
  const { errors, getValues, setValue, unregister, watch } = useFormContext();
  const attemptsIds = watch(attemptsFormFieldKey, []);
  const { length: attemptsLength } = attemptsIds;

  const handleAddAttempt = useCallback(() => {
    const id = getId();
    const attempts = getValues()[attemptsFormFieldKey] || [];

    setValue(attemptsFormFieldKey, [...attempts, id]);
  }, [getValues, setValue]);

  const handleRemoveAttempt = useCallback(
    attemptId => () => {
      unregister(buildAttemptsFormKey(attemptId));

      if (attemptsLength === 1) {
        setValue(attemptsFormFieldKey, []);
        unregister(attemptsFormFieldKey);
      } else {
        const attempts = getValues()[attemptsFormFieldKey];
        const newAttempts = attempts.filter(id => id !== attemptId);

        setValue(attemptsFormFieldKey, newAttempts, true);
      }
    },
    [attemptsLength, getValues, setValue, unregister]
  );

  return {
    attemptsIds,
    attemptsLength,
    handleAddAttempt,
    handleRemoveAttempt,
    shouldDisableAddAttemptButton: !validateInitialBulkIsFilledCorrectly({ errors, watch })
  };
};
